import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

import { useStyles } from './styles';

import { ReactComponent as EsqueciMinhaSenhaIcon } from '../../assets/icons/iconEsqueciMinhaSenha.svg';
import CustomButton from '../../components/CustomButton/CustomButton';
import ROUTES_NAME from '../../consts/routes-name';
import { AutenticationActions } from '../../store/ducks/autentication';

export default function UsuarioValidadoPage() {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignItems="center"
    >
      <Grid
        item
        xs={12}
        sm={7}
        md={5}
        xl={3}
        elevation={0}
        className={classes.containerGrid}
      >
        <EsqueciMinhaSenhaIcon className={classes.imagemEsqueciMinhaSenha} />

        <Typography variant="h1" className={classes.titulo}>
          Primeiro acesso
        </Typography>

        <Typography
          variant="h2"
          className={clsx(classes.subTitulo, classes.font400)}
        >
          Seu usuário foi validado com sucesso.
        </Typography>

        <Typography
          variant="h3"
          className={clsx(classes.subTitulo, classes.font500)}
        >
          Para acessar a área logada, faça seu login.
        </Typography>

        <Grid item xs={12}>
          <CustomButton
            className={classes.button}
            content="VOLTAR PARA LOGIN"
            variant="contained"
            onClickCallBack={() => {
              dispatch(AutenticationActions.setIsValidadoUsuario(false));
              navigate(ROUTES_NAME.HOME);
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
